import { useState, useEffect } from 'react';

//green background
export function ToastMessage(props) {
    const show = props.show
    if (show) {
        return <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="liveToast" class="toast fade show text-bg-success" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header">
            <strong class="me-auto">메세지</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" onClick={props.closeBtn}></button>
            </div>
            <div class="toast-body">
                {props.msg}
            </div>
        </div>
        </div>;
    }
    return "";
}

//Warn, yellow background
export function ToastWarnMessage(props) {
    const show = props.show
    if (show) {
        return <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="liveToast" class="toast fade show text-bg-warning" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header">
            <strong class="me-auto">메세지</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" onClick={props.closeBtn}></button>
            </div>
            <div class="toast-body">
                {props.msg}
            </div>
        </div>
        </div>;
    }
    return "";
}

//Danger, red background
export function ToastDangerMessage(props) {
    const show = props.show
    if (show) {
        return <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="liveToast" class="toast fade show text-bg-danger" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header">
            <strong class="me-auto">메세지</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" onClick={props.closeBtn}></button>
            </div>
            <div class="toast-body">
                {props.msg}
            </div>
        </div>
        </div>;
    }
    return "";
}